import React, {FC} from 'react'
import {Redirect, RouteComponentProps} from 'react-router-dom'
import {DefaultLayout} from 'components'
import {LayoutProps} from 'components/Layouts/Layout.types'
import {useAppSelector} from 'app/store'
import {RouteTransition} from './AnimatedRoutes'
import {CASBRoutesEnum, OIDCRouteEnum} from 'interfaces'

export const PublicRoute: FC<{
  component: FC<RouteComponentProps>
  path: string | string[]
  layout?: FC<LayoutProps>
  layoutProps?: {bgColor?: string; lgColumns?: string}
  exact?: boolean
}> = ({
  component: Component,
  layout: ComponentLayout,
  layoutProps,
  ...rest
}) => {
  const user = useAppSelector(state => state.user)
  const Layout = ComponentLayout ?? DefaultLayout
  const layoutStyles = {
    lgColumns: layoutProps?.lgColumns ?? 'lg:grid-cols-10',
    bgColor: layoutProps?.bgColor ?? 'bg-white',
  }

  const byPassRoute = [
    '/settings/grant-access',
    CASBRoutesEnum.GRANT_ACCESS,
    CASBRoutesEnum.ACCESS_GRANTED,
    CASBRoutesEnum.ACCESS_DENIED,
    CASBRoutesEnum.SYNC_FAILURE,
    '/import-callback',
    '/settings',
    OIDCRouteEnum.BASE,
  ]

  const renderPublicComponent: React.FC<RouteComponentProps> = props => {
    return user?.current?.token && !byPassRoute.includes(props?.match.path) ? (
      user.onboardingCompleted ? (
        <Redirect to="/analytics/overview" />
      ) : (
        <Redirect to="/onboarding" />
      )
    ) : (
      <Layout {...layoutStyles}>
        <Component {...props} />
      </Layout>
    )
  }
  return <RouteTransition {...rest} render={renderPublicComponent} />
}
